module.exports = __webpack_public_path__ + "static/img/01.ce93ea5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/events/180119/01.png
// module id = doco
// module chunks = 0